import { createResourceKeys } from "@/lib/resource-context";

export const organizationLoggingKeys = {
  all: ["organization-logging"] as const,
  policy: (organizationId: string) =>
    [...organizationLoggingKeys.all, "policy", organizationId] as const,
};

// The execution-history surface caches this policy for five minutes to caption
// its empty state, and it ships on its own release cadence. Its cache keys come
// from the shared resource factory, so naming the resource is enough to address
// them from here — this page does not depend on that surface being present.
// Until it is, nothing is stored under the prefix and clearing it is a no-op.
export const executionHistoryKeys = createResourceKeys("tool_executions");
